export const COMMODITIES = [
  {
    slug: "gold-dore",
    group: "I",
    name: "Gold Doré",
    spec: "Au 95.89% · 23.01 Karat · XRF Verified",
    tag: "Core Desk",
    origin: "DRC & West African corridors",
    img: "/assets/assay-xrf-scan.webp",
    gallery: ["/assets/dore-bars-pile.webp", "/assets/dore-nuggets-hand.webp", "/assets/gold-powder.webp", "/assets/gold-dust.webp", "/assets/assay-xrf-screen.webp"],
    desc: "Mine-gate doré from verified producers in the DRC and West African corridors, exported under compliant frameworks with documented chain of custody from the point of extraction. Every lot is screened on site by handheld XRF before it enters the network — no unverified source advances.",
    assay: {
      instrument: "Olympus Vanta XRF · Precious Metals Mode",
      sample: "Sample #5299 · NAV Tools · 1.1 sec scan",
      karat: { value: 23.01, sigma: 0.62 },
      readings: [
        { el: "Au", pct: 95.89, sigma: 2.58 },
        { el: "Ag", pct: 4.11, sigma: 0.93 },
      ],
    },
    standards: ["FATF-aligned export", "OECD DDG chain of custody", "On-site XRF verification"],
  },
  {
    slug: "gold-bullion",
    group: "I",
    name: "Gold Bullion",
    spec: "99.5%+ · LBMA-Standard · 999.9 Fine",
    tag: "Core Desk",
    origin: "Swiss · U.S. · Hong Kong refineries",
    img: "/assets/inspection.webp",
    gallery: ["/assets/hero-bars.webp", "/assets/nugget-skm.webp"],
    desc: "Investment-grade refined gold from legally verified origins — Swiss, U.S., and Hong Kong refineries with recognized stamps. Full documentation package: assay certificate, serial inventory, and vault-to-vault custody record on every bar.",
    assay: {
      instrument: "Independent refinery assay",
      sample: "Good Delivery standard",
      readings: [
        { el: "Au · Good Delivery minimum", pct: 99.5 },
        { el: "Au · Refined 999.9", pct: 99.99 },
      ],
    },
    standards: ["LBMA-standard refineries", "Serialized & allocated", "Vault-to-vault settlement"],
  },
  {
    slug: "copper-cathode",
    group: "I",
    name: "Copper Cathodes & Ingots",
    spec: "Cu 99.99% · LME Grade A",
    tag: "Active",
    origin: "Zambia Copperbelt",
    img: "/assets/copper-cathodes.webp",
    gallery: ["/assets/copper-bales.webp", "/assets/copper-scrap-hand.webp"],
    desc: "Electrolytic copper cathode at 99.99% LME standard from Copperbelt origin, alongside ingots and high-grade scrap supply. Export documentation, loading supervision, and settlement structured end-to-end.",
    assay: {
      instrument: "Electrolytic refinery certification",
      sample: "LME Grade A contract standard",
      readings: [{ el: "Cu", pct: 99.99 }],
    },
    standards: ["LME Grade A", "Zambia Copperbelt origin", "Export documentation support"],
  },
  {
    slug: "strategic-minerals",
    group: "I",
    name: "Antimony · Tungsten · Titanium · Niobium",
    spec: "Critical Industrial & Aerospace Grades",
    tag: "Mandate Only",
    origin: "Verified producers, mandate-specific",
    img: "/assets/ore-rocks.webp",
    gallery: ["/assets/container-loading.webp"],
    desc: "Critical minerals for alloys, flame retardants, aerospace, and strategic reserve mandates. Sourced against specific mandates only, with producer-level verification and corridor-specific compliance review.",
    assay: null,
    standards: ["Mandate-specific sourcing", "Producer-level verification", "Strategic reserve experience"],
  },
  {
    slug: "lithium",
    group: "II",
    name: "Lithium",
    spec: "Li 11% · Raw / Industrial Grade",
    origin: "East & Central African corridors",
    img: "/assets/ore-rocks.webp",
    gallery: ["/assets/container-loading.webp"],
    desc: "Raw and industrial-grade lithium feedstock for battery and industrial buyers, sourced through verified producers in our East and Central African supply corridors.",
    assay: {
      instrument: "Independent laboratory assay",
      sample: "Raw / industrial grade",
      readings: [{ el: "Li", pct: 11 }],
    },
    standards: ["Corridor-verified origin", "Export documentation", "Batch assay reporting"],
  },
  {
    slug: "cobalt",
    group: "II",
    name: "Cobalt",
    spec: "Co 28–35%",
    origin: "DRC corridor",
    img: "/assets/ore-rocks.webp",
    gallery: ["/assets/container-loading.webp"],
    desc: "Cobalt ore and concentrates at 28–35% from the DRC corridor, with OECD-aligned due diligence applied at every hand-off in a region where provenance is the price of entry.",
    assay: {
      instrument: "Independent laboratory assay",
      sample: "Ore & concentrate range",
      readings: [{ el: "Co", min: 28, max: 35 }],
    },
    standards: ["OECD DDG five-step framework", "DRC corridor review", "Conflict-mineral screening"],
  },
  {
    slug: "coltan",
    group: "II",
    name: "Coltan (Tantalite)",
    spec: "Ta₂O₅ 34% · 38% · 45%",
    origin: "Rwanda & DRC corridors",
    img: "/assets/ore-rocks.webp",
    gallery: ["/assets/container-loading.webp"],
    desc: "Tantalite in three graded purities — 34%, 38%, and 45% Ta₂O₅ — from verified cooperatives in the Rwanda and DRC corridors, under Dodd-Frank Section 1502-aligned due diligence.",
    assay: {
      instrument: "Independent laboratory assay",
      sample: "Three verified grades",
      readings: [
        { el: "Ta₂O₅ · Grade 1", pct: 34 },
        { el: "Ta₂O₅ · Grade 2", pct: 38 },
        { el: "Ta₂O₅ · Grade 3", pct: 45 },
      ],
    },
    standards: ["Dodd-Frank 1502 aligned", "Recognized cooperatives", "Grade-segregated lots"],
  },
  {
    slug: "cassiterite",
    group: "II",
    name: "Cassiterite",
    spec: "Sn 60–75%",
    origin: "East & Central African corridors",
    img: "/assets/ore-rocks.webp",
    gallery: ["/assets/container-loading.webp"],
    desc: "Tin ore at 60–75% from corridor-verified producers, with documented custody from mine gate through export.",
    assay: {
      instrument: "Independent laboratory assay",
      sample: "Ore concentrate range",
      readings: [{ el: "Sn", min: 60, max: 75 }],
    },
    standards: ["Corridor-verified origin", "Documented custody", "Export compliance"],
  },
  {
    slug: "manganese",
    group: "II",
    name: "Manganese",
    spec: "Mn 35–40%",
    origin: "West African corridor",
    img: "/assets/ore-rocks.webp",
    gallery: ["/assets/container-loading.webp"],
    desc: "Manganese ore at 35–40% for steel and battery-adjacent industrial buyers, structured under long-term offtake frameworks.",
    assay: {
      instrument: "Independent laboratory assay",
      sample: "Ore range",
      readings: [{ el: "Mn", min: 35, max: 40 }],
    },
    standards: ["Offtake structuring", "Corridor-verified origin", "Batch assay reporting"],
  },
  {
    slug: "aluminium",
    group: "II",
    name: "Aluminium A7",
    spec: "Al 99.7% · Grade A7",
    origin: "Loading Tanzania",
    img: "/assets/container-loading.webp",
    gallery: ["/assets/ore-rocks.webp"],
    desc: "Primary aluminium ingot grade A7 at 99.7%, loading Tanzania, for industrial and manufacturing buyers requiring consistent certified input.",
    assay: {
      instrument: "Smelter certification",
      sample: "Grade A7 ingot",
      readings: [{ el: "Al", pct: 99.7 }],
    },
    standards: ["A7 grade certification", "Loading supervision", "Export documentation"],
  },
  {
    slug: "silica-zinc",
    group: "II",
    name: "Silica & Zinc",
    spec: "Nano-Silica · SHG Zinc",
    origin: "Mandate-specific",
    img: "/assets/container-loading.webp",
    gallery: ["/assets/ore-rocks.webp"],
    desc: "High-purity silica and nano-silica for industrial applications, alongside special high-grade zinc — sourced against verified mandates through the same documentation discipline.",
    assay: null,
    standards: ["Mandate-specific sourcing", "Producer verification", "Documented logistics"],
  },
];

export const GROUP_I = COMMODITIES.filter((c) => c.group === "I");
export const GROUP_II = COMMODITIES.filter((c) => c.group === "II");
export const findCommodity = (slug) => COMMODITIES.find((c) => c.slug === slug);
